import React from 'react';
import { translate } from 'react-i18next';

const NotFound = ({ t, title = '404 : Not Found', description = '' }) => {
  return (
    <div>
      <h1>{t(title)}</h1>
      {description !== '' && <h1>{t(description)}</h1>}
    </div>
  );
};

export default translate()(NotFound);
